<template>
  <div class='UserHeader'>
    <div class="c-user">
      Usuário
    </div>
    <div style="width: 16%" class="mobile-none">
      Nome
    </div>
    <div style="width: 16%" class="mobile-none">
      Sobrenome
    </div>
    <div class="c-email">
      Email
    </div>
    <div class="cont-status">
      Status
    </div>
    <div class="action">
      Ações
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserHeader'
}
</script>

<style scoped>
.UserHeader {
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  padding: 1%;
}

.c-user {
  width: 18%;
}

.c-email {
  width: 29%;
}

.cont-status {
  width: 5%;
}

.action {
  width: 16%;
}

@media (max-width: 500px) {
  .mobile-none {
    display: none;
  }
  .c-user {
    width: 20%;
  }
  .c-email {
    width: 40%;
  }
  .cont-status {
    width: 20%;
  }
  .action {
    width: 20%;
  }
}
</style>
